import React, { useState } from "react";
import { Stack, TextField, Typography, Button } from "@mui/material";
import { addUnit, removeUnit } from "./unitSlice";
import { useDispatch } from "react-redux";
import { CreateUnit } from "./httpCalls";

function AddUnit({ onClose }) {
  const companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const [state, setState] = useState({
    loading: false,
    title: "",
  });

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    dispatch(addUnit(state.title));
    onClose();
    CreateUnit(companyCode, state.title, dispatch);
  };
  return (
    <Stack spacing={4} direction="column">
      <Typography variant="h5" sx={{ color: "#4EAF51" }}>
      {companyCode == "8553" ? "Add New Size" :"Add New Unit"}
      {/* Add New Unit */}
      </Typography>
      <TextField
        autoFocus
        fullWidth
        name="title"
        label= {companyCode == "8553" ? "Add Size" :"Add Unit"}

        value={state.title}
        onChange={handleChange}
        variant="outlined"
      />
      <Stack direction="row" justifyContent="space-evenly">
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
}

export default AddUnit;
